module.exports = __webpack_public_path__ + "static/media/readme.d41d8cd9.md";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/readme.md
// module id = 1052
// module chunks = 114